module.exports = __webpack_public_path__ + "img/xmas_honsu_catch.7eb7b5b3.jpg";